<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            :actions="false"
  >
  </g-master>
</template>
<script>
  export default {
    data () {
      return {
        master: {
          valoresExpandidos: [
            {label: 'Trabajo realizado', column: 'work'},
            {label: 'Estado', column: 'status_desc'},
            {label: 'Cantidad de horas', column: 'n_hours'}
          ],
          endpoint: 'co_legal_hist',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'id_lh'
            },
            columns: [
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Salario mínimo', dataIndex: 'salmin', sorter: true},
              {title: 'Subtra', dataIndex: 'subtra', sorter: true},
              {title: 'Mínimo integral', dataIndex: 'minintegral', sorter: true},
              {title: 'Uvt', dataIndex: 'uvt', sorter: true},
              {title: 'Tope excento', dataIndex: 'tope_excento', sorter: true},
              {title: 'Salario máximo de alimentación', dataIndex: 'sal_max_alim', sorter: true},
              {title: 'Tope de vivienda', dataIndex: 'tope_vivienda', sorter: true},
              {title: 'Tope de solidaridad', dataIndex: 'tope_solid', sorter: true},
              {title: 'Tope ingreso año anterior', dataIndex: 'tope_ing_anoant', sorter: true},
              {title: 'Tope renta excento', dataIndex: 'tope_renta_excento', sorter: true},
              {title: 'Tope cer salud', dataIndex: 'tope_cer_salud', sorter: true},
              {title: 'Tope cer dependiente', dataIndex: 'tope_cer_dependiente', sorter: true},
              {title: 'Tope seguridad social', dataIndex: 'tope_ss', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['id'],
    computed: {
      parentData () {
        return {
          id: this.id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/CoLegal/CoLegalHist.vue